import React from 'react';
import { SEO, SEOConfig } from './SEO';
import { MainFooter } from './Footer';
import { Header } from './Header';

const AGBPage = () => {
  return (
    <>
      <SEO {...SEOConfig.agb} />
      <div className="min-h-screen bg-white">
      <Header />

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
        {/* Page Header */}
        <div className="text-center mb-32">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            Allgemeine Geschäftsbedingungen
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-teal-700 to-blue-500 mx-auto mb-6"></div>
          <p className="text-lg text-gray-700">
            EnBet-Consulting UG für die Nutzung von IDA
          </p>
        </div>

        {/* Content */}
        <div>
          <div className="prose prose-lg max-w-none">
              
              <div className="border-l-4 border-gray-300 p-4 mb-6">
                <p className="text-sm text-gray-700">
                  <strong>Stand:</strong> 06.10.2025 – Nur für Unternehmer (§ 14 BGB)
                </p>
                <p className="text-sm text-gray-700 mt-1">
                  <strong>Anbieter / Kontakt:</strong><br />
                  EnBet-Consulting UG (haftungsbeschränkt)<br />
                  Im Tal 30, 34270 Schauenburg<br />
                  Vertreten durch den Geschäftsführer: Sebastian Funke<br />
                  E-Mail: info@idaki.de | Telefon: +49 (0) 176 23 94 38 96<br />
                  Umsatzsteuer-ID: DE346037206
                </p>
                <p className="text-sm text-gray-900 font-semibold mt-2">
                  Hinweis: Verbraucher (§ 13 BGB) sind von der Nutzung ausgeschlossen.
                </p>
              </div>

              {/* 1. Geltungsbereich & Vertragsschluss */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  1. Geltungsbereich & Vertragsschluss
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>1.1</strong> Diese AGB gelten für alle Verträge über die Bereitstellung der SaaS-Plattform IDA inkl. Module, Updates und Support.</p>
                  <p><strong>1.2</strong> Abweichende AGB des Kunden gelten nur bei ausdrücklicher schriftlicher Zustimmung.</p>
                  <p><strong>1.3</strong> Vertragsschluss online mittels aktiv angehaktem Kontrollkästchen („AGB gelesen und akzeptiert") und Button „Kostenpflichtig bestellen" oder durch Signatur eines Bestellformulars. Der Anbieter protokolliert Datum/Uhrzeit (CET), IP, Account-ID, AGB-Version/Hash.</p>
                </div>
              </section>

              {/* 2. Vertragsgegenstand */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  2. Vertragsgegenstand
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>2.1</strong> Bereitstellung eines entgeltlichen, webbasierten Zugriffs auf IDA während der Laufzeit; On-Premise ist nicht geschuldet.</p>
                  <p><strong>2.2</strong> Leistungsüberblick: Mehrmandanten-/Rollenmodell, Checklistenengine (inkl. Frequenzen & Remindern), Responsible-Gaming-Fallakte (ohne Rechtsberatung), Dokumentenverwaltung, Dashboards/Reports (CSV/PDF), Nachrichten/Workflow, Mehrsprachigkeit (DE/EN). Keine Erfassung/Abrechnung von Spieleinsätzen; keine Anbindung an Wettautomaten/Spielsysteme.</p>
                  <p><strong>2.3</strong> Verbindlich sind ausschließlich Leistungsbeschreibung/SLA und Preisblatt in der zum Bestellzeitpunkt gültigen Fassung.</p>
                </div>
              </section>

              {/* 3. Nutzungsrechte & Beschränkungen */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  3. Nutzungsrechte & Beschränkungen
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>3.1</strong> Einfaches, nicht ausschließliches, nicht übertragbares, nicht unterlizenzierbares Nutzungsrecht für die Vertragsdauer.</p>
                  <p><strong>3.2</strong> Untersagt: Reselling/Timesharing, automatisiertes Auslesen außerhalb dokumentierter APIs, Sicherheits-/Lasttests ohne Zustimmung, Reverse Engineering, Umgehung technischer Schutzmaßnahmen.</p>
                  <p><strong>3.3</strong> Open-Source-Bestandteile unterliegen ihren Lizenzen; Informationen werden auf Anfrage bereitgestellt.</p>
                </div>
              </section>

              {/* 4. Accounts, Sicherheit, Mitwirkung */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  4. Accounts, Sicherheit, Mitwirkung
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>4.1</strong> Der Kunde verwaltet Nutzer, Rollen und 2FA (optional), schützt Zugangsdaten und stellt Systemvoraussetzungen sicher (aktueller Browser, Netzwerkfreigaben).</p>
                  <p><strong>4.2</strong> Der Kunde ist für Inhalte/Dateneingaben verantwortlich und garantiert deren Rechtmäßigkeit (u. a. Glücksspiel-, Arbeits-, Jugend-, Datenschutzrecht).</p>
                  <p><strong>4.3</strong> Rügeobliegenheit: Mängel, Störungen und Sicherheitsvorfälle sind unverzüglich mit Reproduktionsangaben zu melden (Ticket inkl. Schweregrad, Screenshots/Logs).</p>
                </div>
              </section>

              {/* 5. Verfügbarkeit, Wartung, Support */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  5. Verfügbarkeit, Wartung, Support
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>5.1</strong> Zielverfügbarkeit: 99,5 %/Monat (exkl. angekündigter Wartung, höherer Gewalt, Drittnetzen/Cloud-Providern und Ursachen außerhalb des Einflussbereichs des Anbieters).</p>
                  <p><strong>5.2</strong> Wartung: planbar mit Vorlauf von 72 h; Notfallwartung jederzeit zulässig.</p>
                  <p><strong>5.3</strong> Supportzeiten: Mo–Fr 09:00–17:00 Uhr CET (bundeseinheitliche Feiertage ausgenommen); Reaktions-/Behebungszeiten gemäß SLA.</p>
                  <p><strong>5.4</strong> Exclusive Remedy: Bei Verfügbarkeitsunterschreitung stehen dem Kunden ausschließlich Service Credits nach SLA zu. Weitergehende Ansprüche sind ausgeschlossen, soweit gesetzlich zulässig.</p>
                </div>
              </section>

              {/* 6. Leistungsänderungen, Roadmap, Beta */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  6. Leistungsänderungen, Roadmap, Beta
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>6.1</strong> Der Anbieter darf IDA weiterentwickeln, Funktionen konsolidieren oder nicht wesentliche Bestandteile ersetzen, ohne die Hauptleistung zu entwerten.</p>
                  <p><strong>6.2</strong> Wesentlich nachteilige Änderungen werden mit angemessener Frist angekündigt; der Kunde hat ein Sonderkündigungsrecht zum Änderungszeitpunkt als einziges Rechtsmittel.</p>
                  <p><strong>6.3</strong> Beta-/Labs-Funktionen werden „as is" ohne Gewähr, ohne SLA und auf eigenes Risiko bereitgestellt.</p>
                </div>
              </section>

              {/* 7. Vergütung, Abrechnung, Fair Use */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  7. Vergütung, Abrechnung, Fair Use
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>7.1</strong> Preise gemäß Preisblatt (Mandant/Shop, Module, Nutzerpakete, Storage/Exports); zzgl. USt.; Abrechnung monatlich im Voraus, Zahlungsziel 14 Tage netto.</p>
                  <p><strong>7.2</strong> Fair-Use-Klausel: Bei übermäßiger Nutzung (z. B. API-Spitzenlast, Massendownloads) kann der Anbieter drosseln oder angemessene Zusatzentgelte gem. Preisblatt berechnen, nach vorheriger Information.</p>
                  <p><strong>7.3</strong> Bei Zahlungsverzug: gesetzliche Zinsen, Mahnkosten; nach Fristsetzung Sperrrecht für Zugänge.</p>
                </div>
              </section>

              {/* 8. Datenschutz & AVV */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  8. Datenschutz & AVV
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>8.1</strong> Abschluss einer Auftragsverarbeitungsvereinbarung (Art. 28 DSGVO) inkl. TOM-Anlage und Liste von Unterauftragsverarbeitern ist Voraussetzung für die Nutzung mit personenbezogenen Daten.</p>
                  <p><strong>8.2</strong> Der Kunde bleibt Verantwortlicher i. S. d. DSGVO (Informationspflichten, Betroffenenrechte, Rechtsgrundlagen).</p>
                  <p><strong>8.3</strong> Drittlandübermittlungen nur mit geeigneten Garantien (z. B. EU-Standardklauseln). Daten nach Vertragsende: Löschung/Rückgabe gem. Anlage „Datenlösch- & Rückgabekonzept".</p>
                </div>
              </section>

              {/* 9. Gewährleistung */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  9. Gewährleistung
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>9.1</strong> Maßgeblich ist die in der Leistungsbeschreibung definierte Beschaffenheit. Unerhebliche Abweichungen begründen keine Mängelrechte.</p>
                  <p><strong>9.2</strong> Der Anbieter behebt gemeldete Mängel nach billigem Ermessen innerhalb der SLA-Fristen. Ansprüche auf Selbstvornahme, Vorschuss oder Minderung sind ausgeschlossen, soweit gesetzlich zulässig.</p>
                  <p><strong>9.3</strong> Kein Rechts-/Compliance-Versprechen: IDA ersetzt keine Rechtsberatung; Berichte/Workflows sind nicht als behördliche/steuerliche Meldung bestimmt.</p>
                </div>
              </section>

              {/* 10. Haftung */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  10. Haftung
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>10.1</strong> Unbeschränkte Haftung bei Vorsatz, grober Fahrlässigkeit, Verletzung von Leben, Körper, Gesundheit sowie nach ProdHaftG.</p>
                  <p><strong>10.2</strong> Bei einfacher Fahrlässigkeit nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten), begrenzt auf den vorhersehbaren, vertragstypischen Schaden; Höchstgrenze: max. 50 % der in den letzten 12 Monaten gezahlten Nettoentgelte, insgesamt höchstens 50.000 € pro Vertragsjahr (der niedrigere Betrag gilt).</p>
                  <p><strong>10.3</strong> Ausschluss mittelbarer Schäden und Folgeschäden, insbesondere entgangener Gewinn, Produktionsausfall, Nutzungs-/Datenverluste, Wiederherstellungskosten, Rechtsverfolgungskosten, Vertragsstrafen Dritter, soweit gesetzlich zulässig.</p>
                  <p><strong>10.4</strong> Für Datenverluste haftet der Anbieter nur, soweit der Kunde angemessene Datensicherungen durchgeführt hat und der Verlust trotz dessen eingetreten wäre.</p>
                  <p><strong>10.5</strong> Force-Majeure & Drittnetze/Cloud: Keine Haftung für Ausfälle außerhalb des Einflussbereichs (Internet-Backbone, Cloud-Provider, DDoS, behördliche Anordnungen).</p>
                </div>
              </section>

              {/* 11. Drittleistungen & Schnittstellen */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  11. Drittleistungen & Schnittstellen
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>11.1</strong> Soweit IDA Dritt-Dienste (Hosting, Auth, Reporting) einbindet, gelten deren Verfügbarkeiten ergänzend; kein Einstand für deren Störungen.</p>
                  <p><strong>11.2</strong> Schnittstellen können sich ändern; der Anbieter stellt zumutbare Migrationshinweise bereit.</p>
                </div>
              </section>

              {/* 12. Compliance, verbotene Nutzung, Freistellung */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  12. Compliance, verbotene Nutzung, Freistellung
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>12.1</strong> Untersagt sind rechts- oder vertragswidrige Nutzungen, insb. Verstöße gegen Glücksspiel-, Arbeits-, Jugend-, Steuer- oder Datenschutzrecht.</p>
                  <p><strong>12.2</strong> Der Kunde stellt den Anbieter von Ansprüchen Dritter frei, die aus seiner rechtswidrigen Nutzung resultieren, inkl. angemessener Rechtsverteidigungskosten.</p>
                </div>
              </section>

              {/* 13. Laufzeit, Kündigung, Offboarding */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  13. Laufzeit, Kündigung, Offboarding
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>13.1</strong> Mindestlaufzeit 12 Monate, automatische Verlängerung um 12 Monate; Kündigungsfrist 3 Monate zum Laufzeitende.</p>
                  <p><strong>13.2</strong> Außerordentliche Kündigung aus wichtigem Grund bleibt unberührt.</p>
                  <p><strong>13.3</strong> Nach Vertragsende: Sperre der Zugänge; Datenbereitstellung innerhalb von 30 Tagen via Self-Service als CSV/PDF; zusätzliche Aufbereitung gegen Aufwandsvergütung.</p>
                </div>
              </section>

              {/* 14. Änderungen der AGB/Preise */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  14. Änderungen der AGB/Preise
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>14.1</strong> Der Anbieter kann AGB/Preisblatt ändern, wenn berechtigte Interessen dies erfordern (Gesetz, Sicherheit, Markt, neue Funktionen).</p>
                  <p><strong>14.2</strong> Mitteilung in Textform mit 6-Wochen-Frist; Zustimmungsfiktion bei ausbleibendem Widerspruch. Bei fristgerechtem Widerspruch kann der Anbieter den Vertrag zum Änderungszeitpunkt außerordentlich kündigen.</p>
                  <p><strong>14.3</strong> Preisänderungen gelten nur für zukünftige Abrechnungszeiträume.</p>
                </div>
              </section>

              {/* 15. Vertraulichkeit & Referenzen */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  15. Vertraulichkeit & Referenzen
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>15.1</strong> Vertrauliche Informationen sind geheim zu halten.</p>
                  <p><strong>15.2</strong> Der Anbieter darf den Kunden als Referenz (Name/Logo) nennen, sofern der Kunde dem nicht in Textform widerspricht.</p>
                </div>
              </section>

              {/* 16. Abtretung, Aufrechnung, Zurückbehaltung */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  16. Abtretung, Aufrechnung, Zurückbehaltung
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>16.1</strong> Forderungen dürfen abgetreten werden; Vertragsübernahme mit Zustimmung des Kunden (diese darf nicht unbillig verweigert werden).</p>
                  <p><strong>16.2</strong> Aufrechnung nur mit unbestrittenen oder rechtskräftig festgestellten Forderungen; Zurückbehaltung nur aus demselben Vertragsverhältnis.</p>
                </div>
              </section>

              {/* 17. Schlussbestimmungen */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  17. Schlussbestimmungen
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>17.1</strong> Rechtswahl: Deutsches Recht; UN-Kaufrecht ausgeschlossen.</p>
                  <p><strong>17.2</strong> Gerichtsstand: Sitz des Anbieters (ausschließlich).</p>
                  <p><strong>17.3</strong> Form: Textform (E-Mail, Portal-Hinweis) genügt.</p>
                  <p><strong>17.4</strong> Salvatorische Klausel: Unwirksamkeit einzelner Bestimmungen lässt den Vertrag im Übrigen unberührt.</p>
                  <p><strong>17.5</strong> Vertragssprache: Deutsch; Übersetzungen sind unverbindlich.</p>
                </div>
              </section>

              {/* Website-Bestätigung */}
              <section className="mb-8 border-l-4 border-gray-300 p-6">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Website-Bestätigung
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p><strong>Clickwrap Pflichtfeld:</strong> nicht vorangekreuzte Checkbox „AGB gelesen und akzeptiert"; Links auf AGB-Version (PDF), SLA, Preisblatt, AVV.</p>
                  <p><strong>Beweisführung:</strong> Speichern von User-ID, Mandanten-ID, Timestamp (CET), IP, User-Agent, AGB-Versions-Hash; Versand einer Bestätigungsmail mit Versionsangabe.</p>
                  <p><strong>Versionierung:</strong> Jede Änderung erzeugt neue Versions-ID/Hash; Banner/In-App-Notice mit 6-Wochen-Frist und Zustimmungsfiktion gem. Ziff. 14.</p>
                  <p><strong>AVV-Opt-in:</strong> Separate Checkbox „AVV abgeschlossen" + Download des individualisierten AVV.</p>
                  <p><strong>Service-Credits:</strong> Selbstbedienung im Admin-Panel (Antrag innerhalb 10 Kalendertagen nach Ereignis).</p>
                </div>
              </section>

          </div>
        </div>
      </main>

      <MainFooter />
    </div>
    </>
  );
};

export default AGBPage;